<template>
    <v-card>
        <v-snackbar
            v-model="snackbar"
            :color="color"
            right
            top
            multi-line
            app
        >
            {{snackbarText}}
            <v-btn
            text
            dark
            @click="snackbar = false"
            >
            Fermer
            </v-btn>
        </v-snackbar>
        <v-card-title>
        <span class="headline">Ajouter Client</span>
        </v-card-title>
        <v-card-text>
            
        <v-container>
            <v-form v-model="valid">
                <v-row>
                
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field label="Code Client*" outlined disabled v-model="customerTmp.code_client" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field label="Nom Complet / Raison Sociale*" outlined :rules="infoRules" v-model="customerTmp.fullname"  required></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" sm="12">
                        <v-text-field label="Profession / Secteur D'activité" outlined v-model="customerTmp.profession" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12">
                        <v-text-field label="Matricule Fiscale*" outlined :rules="infoRules"  v-model="customerTmp.mf" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Email*" outlined :rules="infoRules" v-model="customerTmp.email" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Mot de Passe*" outlined :rules="infoRules" v-model="customerTmp.password" type="password" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12">
                        <v-text-field label="Adresse" outlined v-model="customerTmp.adresse" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Région" outlined v-model="customerTmp.region" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Code Postal" outlined v-model="customerTmp.code_postal" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="N° Téléphone*" outlined :rules="infoRules" v-model="customerTmp.tel" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="N° Fax" outlined v-model="customerTmp.fax" required></v-text-field>
                    </v-col>
                </v-row>
             </v-form>
        </v-container>
        <small>*toutes les cases indiquées avec étoiles sont obligatoires</small>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeNewCustomer(0)">Fermer</v-btn>
        <v-btn style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" @click="setNewCustomer">Ajouter</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    export default {
        name: 'new-customer',
        data: () => ({
            customersList: [],
            customerTmp: {
                code_client: 0
            },
            valid: false,
            snackbar: false,
            snackbarText: '',
            color: "success",
            infoRules: [
                v => !!v || 'Veuillez saisir une valeur',
            ],
            
        }),
        mounted() {
            this.axios
            .get('/client/listing')
            .then(response => {
                var customersData = response.data
                if(customersData.length > 0){
                    var nextCode = customersData.reduce((max, p) => p.code_client > max ? p.code_client : max, customersData[0].code_client)
                    nextCode = Number(nextCode.slice(3, nextCode.length))
                    nextCode = nextCode+1
                    nextCode = '411'+nextCode.toString().padStart(6, "0")
                }else{
                    nextCode = '411000001'
                }
                this.customerTmp.code_client = nextCode
            })

            

        },
        methods: {
            closeNewCustomer(val){
                this.$emit('closeNewCustomer', val)
            },
            setNewCustomer(){
                if(this.valid === false){
                    this.color = "error"
                    this.snackbar = true
                    this.snackbarText = "Veuillez remplir tous les champs obligatoires."
                }else{
                   this.axios
                        .post('/client/create', this.customerTmp, {
                        }).then((res) => {
                            if(res.data === 'error'){
                            this.color = "error"
                            this.snackbarText = "Essayez de remplir tous les champs obligatoires."
                            this.snackbar = true
                            }else{
                            this.$emit('reloadData')
                            this.closeNewCustomer(1)
                            }
                        }).catch(e => {
                            this.color = "error"
                            this.snackbar = true
                            this.snackbarText = "Un erreur est survenu, essayez plus tard."
                            console.log(e)
                        })
                }
            }
        }
    }
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/dashboard/customer/add.vue